module.exports = __webpack_public_path__ + "static/mw6-dceb85bce369f94d4a6731bbe3e1375b.jpg";